export interface ISearchCriteria {
  argument: string;
  selector?: string;
  operator?: string;
  values?: Set<string>;
}
